import { Modal } from 'components'
import TrackEvent from 'components/GAnalitics'
import { useReduxSelector } from 'hooks'
import ForgotForm from './forgot-form'
import { useHistory } from "react-router-dom";

export const forgotModalName = 'ForgotPasswordModal'

export const ForgotModal: React.FC = () => {
  const history = useHistory();
  const { location } = history;
  const { modal } = useReduxSelector((state) => state.props)
  const { show = false } = modal[forgotModalName] || {}

  return (
    <Modal
      open={show}
      maxWidth="sm"
      name={forgotModalName}
      title="Восстановление пароля"
      onCloseDialog={() => history.push({ search: '' })}
      onOpen={() => TrackEvent({ eventCategory: 'Forgot', eventAction: 'open_f_form' })}
    >
      <ForgotForm rootModal={forgotModalName} />
    </Modal>
  )
}
